import React, { useState, useEffect } from 'react'
import Container from '@mui/material/Container'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

function Summary(props) {
    const [fileName, setFileName] = useState('')
    const [tabData, setTabData] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [measureDimension, setMeasureDimension] = useState({ "id":  -1, "name": "", "outputFormat": [], "ranges": [], "segments": [], "type": 1 })
    const [tableHasHeader, setTableHasHeader] = useState(false)
    const [namedColumns, setNamedColumns] = useState(false)
    const [headerRow, setHeaderRow] = useState(0)
    const [factsColumnRanges, setFactsColumnRanges] = useState([])
    const [sources, setSources] = useState([''])
    const [ranges, setRanges] = useState([''])
    const [globalFiles, setGlobalFiles] = useState([])
    const [excludedFileName, setExcludedFileName] = useState('')
    const [alreadyExists, setAlreadyExists] = useState(false)

    // trigger on component mount
    useEffect(() => {
        setDimensions(props.dimensions)
        setTabData(props.previewData)
        setTableHasHeader(props.tableDefinition.tableHasHeader)
        setNamedColumns(props.tableDefinition.namedColumns)
        setHeaderRow(props.headerRow)
        setFactsColumnRanges(props.factsColumnRanges)
        setGlobalFiles(props.jobFiles)
        setExcludedFileName(props.wizardFileName)

        // Build string of data source names
        let toSetAsSources = []
        for (let x = 0; x < props.previewData.length; x++) {
            toSetAsSources.push(props.previewData[x]["tabName"])
        }
        setSources(toSetAsSources)

        // Build string of column ranges
        let toSetAsRanges = []
        for (let x = 0; x < props.factsColumnRanges.length; x++) {
            toSetAsRanges.push(getColumnRangeString(props.factsColumnRanges[x]))
        }
        setRanges(toSetAsRanges)

        // Get the measures dimension
        for (let x = 0; x < props.dimensions.length; x++) {
            if (props.dimensions[x]["id"] === -1) {
                setMeasureDimension(props.dimensions[x])
            }
        }
    }, [])

    useEffect(() => {
        if (props.wizardFileName && props.wizardFileName !== fileName) {
            setFileName(props.wizardFileName)
        }
    }, [props.wizardFileName])

    /**
     * getColumnRangeString
     * * Equivalent of the ToString method from the C# class when giving range representation
     * @param {object} range - Range object
     * @returns {string} Name of object
    */
    function getColumnRangeString(range) {
        if (range["absolute"]) {
            if (range["leftIsAnchored"] && range["rightIsAnchored"]) {
                return `L Anchor:${range["left"] + 1}; R Anchor:${range["tableWidth"] - range["right"]}`
            } else if  (range["leftIsAnchored"]) {
                return `L Anchor:${range["left"] + 1}; Width:${range["right"] - range["left"] + 1}`
            } else {
                return `R Anchor:${range["tableWidth"] - range["right"]}; Width:${range["right"] - range["left"] + 1}`
            }
        } else {
            return range["name"]
        }
    }

    function doesThisFileAlreadyExists(newFileName) {
        let rtnVal = false

        for (let x = 0; x < globalFiles.length; x++) {
            if (globalFiles[x]["name"].trim().toLowerCase() === newFileName.trim().toLowerCase() + '.json' && excludedFileName.trim().toLowerCase() !== newFileName.trim().toLowerCase()) {
                rtnVal = true
            }
        }

        return rtnVal
    }

    return <>
        <TextField
            required
            fullWidth
            error={fileName.trim().length === 0}
            label="File Name"
            value={fileName}
            onChange={(e) => {
                e.preventDefault()

                let newWizardFileName = e.target.value
                let isValid = doesThisFileAlreadyExists(newWizardFileName)
                
                setAlreadyExists(isValid)
                setFileName(newWizardFileName)

                if (props.onSave) {
                    props.onSave(newWizardFileName, isValid)
                }
            }}
        />
        <Typography>Summary:</Typography>
        {alreadyExists ? <Typography sx={{ 'fontWeight': 'bold', 'color': 'Red' }}>File Name Already Exists</Typography> : null}
        <Container maxWidth={false}>
            {(props.wizardFileName && props.wizardFileName !== '' ? <Typography>File Name: {props.wizardFileName}</Typography> : null)}
            <Typography>Data Source:</Typography>
            <Typography>Table(s): File: {sources.join(", ")}</Typography>
            <Typography mt={2}>{' '}</Typography>
            <Typography>Import Wizard Configuration:</Typography>
            <Typography>Generic Tabular</Typography>
            <Typography>Table Definition:</Typography>
            <Typography>Has header: {tableHasHeader ? 'Yes' : 'No'}</Typography>
            <Typography>Columns referenced by name: {namedColumns ? 'Yes' : 'No'}</Typography>
            <Typography mt={2}>{' '}</Typography>
            <Typography>Fact source:</Typography>
            <Typography>Top row: {headerRow}</Typography>
            <Typography>Columns range(s): {ranges.join(", ")}</Typography>
            <Typography mt={2}>{' '}</Typography>
            <Typography>Measures:</Typography>
            <Typography>ID Source:</Typography>
            {measureDimension["ranges"].map((range, index) => {
                return <div key={`measure-range-${index}`}>
                    <Typography>Address: {range["name"]}</Typography>
                    <Typography>Extractor: Full Text</Typography>
                    <Typography>Use Proper Case: {range["useProperCase"] ? "Yes" : "No"}</Typography>
                    <Typography>Use Nulls: {range["useNulls"] ? "Yes" : "No"}</Typography>
                </div>
            })}
            <Typography mt={2}>{' '}</Typography>
            <Typography>Dimensions:</Typography>
            {dimensions.map((dimensionData, index) => {
                if (dimensionData["id"] === -1) {
                    return null
                } else {
                    return <div key={`dimension-group-${index}`}>
                        <Typography>Name: {dimensionData["name"]}</Typography>
                        <Typography>Type: {dimensionData["type"]}</Typography>
                        {dimensionData["ranges"].map((range, rangeIndex) => {
                            return <div key={`dimension-group-${index}-range-${rangeIndex}`}>
                                <Typography>Address: {range["name"]}</Typography>
                                <Typography>Extractor: Full Text</Typography>
                                <Typography>Use Proper Case: {range["useProperCase"] ? "Yes" : "No"}</Typography>
                                <Typography>Use Nulls: {range["useNulls"] ? "Yes" : "No"}</Typography>
                            </div>
                        })}
                        <Typography mt={2}>{' '}</Typography>
                    </div>
                }
            })}
        </Container>
    </>
}

export default Summary